import { Link } from "react-router-dom";
import Grain from "@/components/wam/Grain";
import Cursor from "@/components/wam/Cursor";
import Footer from "@/components/wam/Footer";

/**
 * Shared layout for legal pages. Handles the dark cinematic shell + nav so
 * each policy page only needs its own body content.
 */
export default function LegalLayout({ label, title, effective, children }) {
  return (
    <div className="relative bg-[#070709] text-[#F0ECE4] min-h-screen overflow-x-hidden">
      <Grain />
      <Cursor />
      <header className="fixed left-0 right-0 top-4 md:top-6 z-[100] mx-auto flex justify-center pointer-events-none">
        <div
          className="pointer-events-auto flex items-center gap-2 rounded-full px-3 py-2"
          style={{
            background: "rgba(7,7,9,0.85)",
            border: "1px solid rgba(240,236,228,0.08)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
          }}
        >
          <Link
            to="/"
            className="px-4 py-2 font-mono text-[10px] tracking-[0.28em] text-[#C9A84C]"
          >
            ← SMALL BUSINESS AUTOMATOR
          </Link>
        </div>
      </header>

      <main className="relative pt-40 pb-24 md:pt-48 md:pb-32">
        <div className="mx-auto max-w-[860px] px-6 md:px-10">
          <div className="mb-8 flex items-center gap-4">
            <span className="font-mono text-[10px] tracking-[0.3em] text-[#F0ECE4]/40">
              LEGAL
            </span>
            <span className="font-mono text-[10px] tracking-[0.3em] text-[#C9A84C]">
              {label}
            </span>
          </div>

          <h1
            className="font-display"
            style={{
              fontSize: "clamp(36px, 5.4vw, 72px)",
              lineHeight: 0.98,
              letterSpacing: "-0.035em",
            }}
          >
            {title}
          </h1>

          {effective && (
            <div className="mt-4 font-mono text-[10px] tracking-[0.24em] text-[#F0ECE4]/40">
              LAST UPDATED · {effective.toUpperCase()}
            </div>
          )}

          <div className="mt-14 space-y-8 font-body text-[15px] leading-[1.8] text-[#F0ECE4]/80">
            {children}
          </div>

          <div className="mt-16 flex flex-wrap gap-6 border-t wam-hairline pt-8 font-mono text-[10px] tracking-[0.28em] text-[#F0ECE4]/45">
            <Link to="/privacy" className="hover:text-[#C9A84C] transition-colors">
              PRIVACY POLICY
            </Link>
            <span className="text-[#F0ECE4]/20">·</span>
            <Link to="/terms" className="hover:text-[#C9A84C] transition-colors">
              TERMS OF SERVICE
            </Link>
            <span className="text-[#F0ECE4]/20">·</span>
            <Link to="/disclaimer" className="hover:text-[#C9A84C] transition-colors">
              DISCLAIMER
            </Link>
            <span className="text-[#F0ECE4]/20">·</span>
            <Link to="/" className="hover:text-[#C9A84C] transition-colors">
              ← HOME
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-display text-[20px] md:text-[24px] tracking-[-0.02em] text-[#F0ECE4] mb-4">
        {heading}
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
